import { ref, type Ref } from 'vue'

interface Entity {
  name?: string
  role?: string
  birthDate?: string
  email?: string
  address?: string
  [key: string]: any
}

const activeEntity: Ref<Entity | null> = ref(null)
const activeEntityElement: Ref<HTMLElement | null> = ref(null)
const showEntityCard: Ref<boolean> = ref(false)

export function useEntityCard() {
  const showCard = (entity: Entity, element: HTMLElement): void => {
    console.log('Showing card for entity', entity)
    // If clicking the same entity, toggle the card
    if (activeEntity.value === entity) {
      showEntityCard.value = !showEntityCard.value
      return
    }

    // Show card for new entity
    activeEntity.value = entity
    activeEntityElement.value = element
    showEntityCard.value = true
  }

  const hideCard = (): void => {
    showEntityCard.value = false
  }

  return {
    activeEntity,
    activeEntityElement,
    showEntityCard,
    showCard,
    hideCard
  }
}
